import Group from '../group.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Group.index((fetch) =>
    fetch.get('groups')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
